import { S3Params } from "@/components/LogoUploader";
import { fileService } from "../services/fileService";


export async function fetchImageUrl({
    key,
    bucket:bucketName,
    contentType,
}:S3Params): Promise<string | null> {
  if (!key) return null;

  try {
    const {url} = await fileService.getImageFromkey(key,bucketName,contentType);
    return url;
  } catch (err) {
    console.error("Image fetch error:", err);
    return null;
  }
}

export function parsedIfNotParsed<T = any>(value: unknown): T {
  // Already an object (but not null)
  if (typeof value === "object" && value !== null) {
    return value as T;
  }

  // If it's a string, try parsing
  if (typeof value === "string") {
    try {
      return JSON.parse(value) as T;
    } catch (err) {
      throw new Error("Invalid JSON string");
    }
  }

  // Anything else is invalid
  throw new Error("Value must be an object or a JSON string");
}
export function stringifyIfNotStringified(value: unknown): string {
  // Already a JSON string → return as is
  if (typeof value === "string") {
    return value;
  }

  // Object / Array → stringify
  if (typeof value === "object" && value !== null) {
    try {
      return JSON.stringify(value);
    } catch {
      throw new Error("Unable to stringify value");
    }
  }

  // Primitive values (number, boolean, etc.)
  return JSON.stringify(value);
}

export const getUserFullName = (user:any) => {
  if (!user) return ""
  return [user.firstName, user.middleName, user.lastName, user.nameSuffix].filter(Boolean).join(" ")
}


export const getUserDateFormat = (user:any) => {
  let userDateFormat: string = "MM/DD/YYYY"
  if (user) {
      const {dateFormat} = user
      userDateFormat = dateFormat || "MM/DD/YYYY"
  }
  return userDateFormat
}

export const getUserTimeFormat = (user:any) => {
  let userTimeFormat = "HH:mm"
  if (user) {
      const {timeFormat} = user
      userTimeFormat = timeFormat || '24 H'
      if (userTimeFormat === '12 H') {
          return "hh:mm A"
      }
      return "HH:mm"
  }
  return userTimeFormat
}